import React, { useEffect } from "react";

const CloseWindow = () => {
  useEffect(() => {
    console.log("a");
    window.close("Payment - Discover POS");
  }, []);

  return <div>Purchase Finished.</div>;
};

export default CloseWindow;
